import { cookieConsent } from './cookieconsent.js';
; (() => {


    const cookieLink = document.querySelectorAll('.cookieconsent-link-trigger');
    cookieLink.forEach(el => {
        el.addEventListener('click',
            (e) => {
                e.preventDefault();
                cookieConsent.updateCookieSettings();

            });

    });


    cookieConsent.init({
        categories: [
            {
                type: "required",
                description: "N\xF6dv\xE4ndiga kakor",
                cookies: []
            },
            {
                type: "functional",
                description: "Funktionella kakor",
                cookies: []
            },
            {
                type: "recommended",
                description: "Rekommenderade kakor",
                cookies: []
            },
            {
                type: "embedd",
                description: "Inb\xE4ddat inneh\xE5ll",
                cookies: []
            },
            {
                type: "marketing",
                description: "Statistik och utv\xE4rdering",
                cookies: []
            }
        ],
        text: {
            descriptions: {
                usage:
                    "Vallentuna kommun anv\xE4nder kakor, cookies, f\xF6r att ge dig en b\xE4ttre upplevelse p\xE5 v\xE5ra webbplatser.",
                description:
                    "En del kakor \xE4r n\xF6dv\xE4ndiga f\xF6r att webbplatsen ska fungera, medan andra hj\xE4lper oss analysera hur webbplatsen anv\xE4nds. Du best\xE4mmer vilka kakor du vill godk\xE4nna och kan \xE4ndra dina inst\xE4llningar n\xE4r som helst.",
                required:
                    "Dessa kakor beh\xF6vs f\xF6r att webbplatsen ska fungera korrekt och de kan inte st\xE4ngas av.",
                functional:
                    "Dessa kakor ger dig möjlighet att använda vår chatt och en funktion som läser upp innehåll.",
                recommended:
                    "Dessa kakor ger dig möjlighet att få förslag på relevant innehåll och ett mer träffsäkert sökresultat.",
                embedd:
                    "Dessa kakor ger webbplatsen m\xF6jlighet att visa inb\xE4ddat inneh\xE5ll till exempel kartor och film.",
                marketing:
                    "Dessa kakor ger information om hur webbplatsen anv\xE4nds och hj\xE4lper oss att f\xF6rb\xE4ttra anv\xE4ndarupplevelsen."
            },
            cookieDescriptions: {
                functional: "Acceptera kakor f\xF6r funktionalitet",
                recommended: "Acceptera rekommenderade kakor",
                embedd: "Acceptera kakor f\xF6r inb\xE4ddat inneh\xE5ll",
            },
            btnAccept: "Godk\xE4nn alla kakor",
            btnCustomize: "Anpassa inst\xE4llningar",
            btnSaveCustom: "Spara",
            customizeSettingsHeader: "<h3>Anpassa inst\xE4llningar f\xF6r kakor</h3>",
            customizeHeader: "<h3>Inst\xE4llningar f\xF6r kakor</h3>"
        }
    });

})();


// WEBPACK FOOTER //
// ./Components/Shared/cookie.js